var exports = {
  "kL": "xfd349460--db7952--container",
  "wx": "xfd349460--db7952--header",
  "Qs": "xfd349460--db7952--content",
};

module.exports = exports;
